export const CONSTANTS_SETTINGS = {
	PERSON_SETTING_TYPE: 'person',
	ORG_SETTING_TYPE: 'org',
	BOOKING_CONFIGURATION: 81,
	ACCESS_MODULE: 82,
	LOCKER_MODULE: 83,
	SCIM_TOKEN: 84,
	WORKSPACE_DOMAIN: 86,
	MASTER_CREDENTIAL: 87,
	ENABLE_CARD_ENROLMENT: 89,
	UNLOCK_METHOD: 90,
	ROOMS_CONFIGURATION: 91,
	ENFORCE_DOMAIN_CONTROL: 93,
	INNER_RANGE_MODULE: 94,
	IR_SETTING_LAST_SYNC: 108,
	IR_SETTING_SYNCING: 109,
	TTLOCK_MODULE: 110,
	TTLOCK_CLIENT_ID: 111,
	TTLOCK_CLIENT_SECRET: 112,
	CONTROL_MODULE: 123,
	CONTROL_SETTING_LAST_SYNC: 125,
	CONTROL_SETTING_SYNCING: 126,
	CONTROL_LOCKS_GROUP_ID: 127,
	CONTROL_SYNC_LOCKS: 128,
	CONTROL_SYNC_RECORDS: 129,
	IR_LOG_SYNCING: 130,
	IR_LOG_LAST_SYNC: 131,
	CONTROL_LOG_SYNCING: 132,
	CONTROL_LOG_LAST_SYNC: 133,
	CONTROL_PASSCODE_LENGTH: 134,
	CONTROL_SYNC_PASSCODES: 135,
	ROOMS_MODULE: 136
};
